export default "__VITE_ASSET__c77cc956__"